import { render, staticRenderFns } from "./restrict-chip-list-item.vue?vue&type=template&id=436cb91e&"
import script from "./restrict-chip-list-item.vue?vue&type=script&lang=js&"
export * from "./restrict-chip-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports